export default function Logout() {
  const client = localStorage.getItem("client");

  localStorage.clear();
  sessionStorage.clear();

  if (client) {
    localStorage.setItem("client", client);
  }

  window.location.replace("/");
}